import React, { useState } from "react";
import axios from "axios";


const useCan = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const [canOption, setCanOption] = useState([])
    const mainApi = '/message/backend/can'
    const getCanOption = (params) => {
        axios.get(mainApi, {
            params: {
                // current: 1,
                // pageSize: 20,
                // size: 20,
                // cur_page: 1,
            }
        })
            .then((response) => {
                let data = response.data.data
                data = data.map((value) => {
                    return {
                        label: value?.name,
                        value: value?.can_id,
                        ...value
                    }
                })
                setCanOption(data)
            });
    }
    const getCanData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get(mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postCanData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchCanData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "failure") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteCanData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        canOption: canOption,
        canData: data,
        getCanData,
        postCanData,
        patchCanData,
        deleteCanData,
        getCanOption
    }
}
export { useCan }
